import { useResetRecoilState } from 'recoil';
import { apiKeyListState, newApiKeyState } from '../store';

const useResetDevelop = () => {
  const setApiKeyList = useResetRecoilState(apiKeyListState);
  const setNewApiKey = useResetRecoilState(newApiKeyState);

  const resetDevelop = () => {
    setApiKeyList();
    setNewApiKey();
  };

  return resetDevelop;
};

export default useResetDevelop;
